// extracted by css-extract-rspack-plugin
var _1 = "ySdPlEXJcnVJikuGHKPhkQ--";
var _2 = "VYwSyCqlbxqZScOXWS7GlA--";
export { _1 as "emptyView", _2 as "margin0" }
